import React, { useEffect, useState} from 'react';
import customCSS from './Myplants.module.css'
import ENV from '../../constants/env-constants';
import { useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../../utils/formatNumbers';

function Myplants() {
  
  const userid = localStorage.getItem('userid');
  const [transactions, setTransactions] = useState([]);
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard MyPlants Page' });
    const fetchTransactions = async () => {
      const response = await fetch(`${ENV.API_URL}/api/transactions/${userid}`);
      const data = await response.json();
      console.log(data)
      setTransactions(data);
    };

    fetchTransactions();
  }, []);
  
  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <Helmet>
        <meta charSet="utf-8" />
        <title>My Plants</title>
      </Helmet>
      <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>My plants</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
              <table className={customCSS.table}>
                <thead>
                  <tr>
                    <th className={customCSS.th}>Transaction ID</th>
                    <th className={customCSS.th}>Donated</th>
                    <th className={customCSS.th}>Trees Planted</th>
                  </tr>
                </thead>
                <tbody>
                  {/* filter is added to remove transactions with 0 dollars. */}
                  {/* Why 0 dollars transaction exists? Ans: These are generally added in transactions to add free trees recievers, even though they haven't spend money but the tree is planted on their behalf so it will be like 1 tree for 0 dollars */}
                  {transactions.filter((transaction) => Boolean(transaction.amount)).map((transaction, index) => (
                    <tr key={index}>
                      <td className={customCSS.td}>{transaction.tid}</td>
                      <td className={customCSS.td}>${formatNumbers(transaction.amount)}</td>
                      <td className={customCSS.td}>{formatNumbers(transaction.amount)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    </>
  );
}

export default Myplants;